<template>
  <div class="page-wrapper">
    <!-- PC 端 -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.order_no"
            placeholder="请输入订单号"
            clearable
            style="width: 240px; margin-right: 10px"
          ></el-input>

          <!-- 价格类型筛选 -->
          <el-select
            v-model="searchParams.type"
            placeholder="价格类型"
            style="width: 160px; margin-right: 10px"
            clearable
          >
            <el-option label="提货订单" :value="1" />
            <el-option label="商城订单" :value="2" />
          </el-select>

          <el-select
            v-model="searchParams.status"
            placeholder="订单状态"
            style="width: 180px; margin-right: 10px"
            clearable
          >
            <el-option
              v-for="item in orderStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getOrderList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="订单ID" prop="id" width="80" align="center" />
          <el-table-column label="订单号" prop="order_no" min-width="220" />
          <el-table-column
            label="用户昵称"
            prop="nickname"
            width="100"
            align="center"
          />
          <el-table-column
            label="收货人"
            prop="order_username"
            width="100"
            align="center"
          />
          <el-table-column
            label="联系电话"
            prop="order_mobile"
            width="130"
            align="center"
          />

          <!-- 价格类型 -->
          <el-table-column label="价格类型" width="110" align="center">
            <template slot-scope="scope">
              <span :style="getTypeColor(scope.row.type)">
                {{ scope.row.type == 1 ? '提货订单' : '商城订单' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="商品名称" min-width="260">
            <template slot-scope="scope">
              {{
                scope.row.detail && scope.row.detail[0]
                  ? scope.row.detail[0].goods_name
                  : "无商品"
              }}
            </template>
          </el-table-column>

          <el-table-column
            label="订单金额"
            prop="total_amount"
            width="100"
            align="center"
          />
          <el-table-column
            label="支付金额"
            prop="pay_amount"
            width="100"
            align="center"
          />

          <el-table-column label="订单状态" width="130" align="center">
            <template slot-scope="scope">
              <span :style="getStatusColor(scope.row.status)">
                {{ getOrderStatusText(scope.row.status) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="操作" width="240" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-view"
                @click.stop="handlePcView(scope.row)"
                >查看</el-button
              >

              <!-- 发货 仅待发货状态显示 -->
              <el-button
                v-if="scope.row.status == 2"
                type="text"
                icon="el-icon-document-checked"
                style="color:#00C48C"
                @click.stop="handleDelivery(scope.row)"
                >发货</el-button
              >

              <!-- 取消订单 -->
              <el-button
              v-if="scope.row.status == 1"
                type="text"
                icon="el-icon-close"
                style="color:#F56C6C"
                @click.stop="handleCancelOrder(scope.row)"
                >取消</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 订单详情弹窗 -->
        <el-dialog
          title="订单详情"
          :visible.sync="pcShowCard"
          width="700px"
          center
          close-on-click-modal
          append-to-body
        >
          <div class="order-card" v-if="pcCurrentOrder">
            <div class="order-info">
              <p><label>订单ID：</label><span>{{ pcCurrentOrder.id }}</span></p>
              <p><label>订单号：</label><span>{{ pcCurrentOrder.order_no }}</span></p>
              <p><label>用户昵称：</label><span>{{ pcCurrentOrder.nickname }}</span></p>
              <p><label>收货人：</label><span>{{ pcCurrentOrder.order_username }}</span></p>
              <p><label>联系电话：</label><span>{{ pcCurrentOrder.order_mobile }}</span></p>
              <p><label>收货地址：</label><span>{{ pcCurrentOrder.order_address }}</span></p>
              <p><label>价格类型：</label>
                <span :style="getTypeColor(pcCurrentOrder.type)">
                  {{ pcCurrentOrder.type == 1 ? '提货订单' : '商城订单' }}
                </span>
              </p>
              <p><label>订单金额：</label><span>¥{{ pcCurrentOrder.total_amount }}</span></p>
              <p><label>支付金额：</label><span>¥{{ pcCurrentOrder.pay_amount }}</span></p>
              <p><label>订单状态：</label>
                <span :style="getStatusColor(pcCurrentOrder.status)">
                  {{ getOrderStatusText(pcCurrentOrder.status) }}
                </span>
              </p>
              <p><label>创建时间：</label><span>{{ pcCurrentOrder.created_at }}</span></p>
            </div>

            <div style="margin-top: 20px">
              <p style="font-weight: bold; margin-bottom: 10px">商品信息</p>
              <div
                v-for="item in pcCurrentOrder.detail"
                :key="item.id"
                style="
                  display: flex;
                  align-items: center;
                  gap: 12px;
                  border: 1px solid #eee;
                  padding: 10px;
                  border-radius: 8px;
                "
              >
                <img
                  :src="item.goods_image"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
                <div>
                  <div>{{ item.goods_name }}</div>
                  <div style="font-size: 12px; color: #999">
                    单价：¥{{ item.goods_price }} × {{ item.num }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile-version">
      <div
        class="mobile-order-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.order_no"
            placeholder="订单号"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />

          <!-- 移动端价格类型 -->
          <el-select
            v-model="searchParams.type"
            placeholder="价格类型"
            clearable
            size="medium"
          >
            <el-option label="提货订单" :value="1" />
            <el-option label="商城订单" :value="2" />
          </el-select>

          <el-select
            v-model="searchParams.status"
            placeholder="订单状态"
            clearable
            size="medium"
            style="margin-top: 8px"
          >
            <el-option
              v-for="item in orderStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getOrderList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.order_no }}</div>
                <div class="meta">{{ item.nickname }} | {{ item.order_username }}</div>
                <div class="meta" style="margin-top:2px">
                  <span :style="getTypeColor(item.type)">
                    {{ item.type == 1 ? '提货订单' : '商城订单' }}
                  </span>
                </div>
              </div>
              <div class="status" :style="getStatusColor(item.status)">
                {{ getOrderStatusText(item.status) }}
              </div>
            </div>

            <div style="margin: 8px 0">
              <div style="font-size: 13px; color: #333">
                {{
                  item.detail && item.detail[0]
                    ? item.detail[0].goods_name
                    : "无商品"
                }}
              </div>
            </div>

            <div class="card-body">
              <div>实付：¥{{ item.pay_amount }}</div>
              <div>时间：{{ item.created_at }}</div>
            </div>

            <div class="card-footer">
              <el-button size="mini" type="primary" round @click.stop="handleMobileView(item)">
                查看
              </el-button>

              <!-- 发货 仅待发货状态显示 -->
              <el-button
                v-if="item.status == 2"
                size="mini"
                type="success"
                round
                @click.stop="handleDelivery(item)"
              >
                发货
              </el-button>

              <!-- 取消按钮 -->
              <el-button size="mini" v-if="item.status == 1" type="danger" round @click.stop="handleCancelOrder(item)">
                取消
              </el-button>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="订单详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentOrder" style="padding: 10px 0">
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="订单ID">{{ mobileCurrentOrder.id }}</el-descriptions-item>
              <el-descriptions-item label="订单号">{{ mobileCurrentOrder.order_no }}</el-descriptions-item>
              <el-descriptions-item label="用户昵称">{{ mobileCurrentOrder.nickname }}</el-descriptions-item>
              <el-descriptions-item label="收货人">{{ mobileCurrentOrder.order_username }}</el-descriptions-item>
              <el-descriptions-item label="电话">{{ mobileCurrentOrder.order_mobile }}</el-descriptions-item>
              <el-descriptions-item label="地址">{{ mobileCurrentOrder.order_address }}</el-descriptions-item>
              <el-descriptions-item label="价格类型">
                <span :style="getTypeColor(mobileCurrentOrder.type)">
                  {{ mobileCurrentOrder.type == 1 ? '提货订单' : '商城订单' }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="订单金额">¥{{ mobileCurrentOrder.total_amount }}</el-descriptions-item>
              <el-descriptions-item label="支付金额">¥{{ mobileCurrentOrder.pay_amount }}</el-descriptions-item>
              <el-descriptions-item label="订单状态">
                <span :style="getStatusColor(mobileCurrentOrder.status)">
                  {{ getOrderStatusText(mobileCurrentOrder.status) }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ mobileCurrentOrder.created_at }}</el-descriptions-item>
            </el-descriptions>

            <div style="margin-top: 15px">
              <div style="font-weight: bold; margin-bottom: 8px">商品信息</div>
              <div
                v-for="item in mobileCurrentOrder.detail"
                :key="item.id"
                style="
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  border: 1px solid #eee;
                  padding: 8px;
                  border-radius: 8px;
                "
              >
                <img
                  :src="item.goods_image"
                  style="width: 50px; height: 50px; object-fit: cover"
                />
                <div style="font-size: 13px">
                  <div>{{ item.goods_name }}</div>
                  <div style="color: #999">
                    ¥{{ item.goods_price }} × {{ item.num }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "OrderTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 15,
        order_no: "",
        type: "",    // 初始为空字符串，不用 .number
        status: "",
      },
      orderStatusList: [
        { value: 1, label: "待付款" },
        { value: 2, label: "待发货" },
        { value: 3, label: "待收货" },
        { value: 4, label: "已完成" },
        { value: 5, label: "已取消" },
      ],
      pcShowCard: false,
      pcCurrentOrder: null,
      mobileShowCard: false,
      mobileCurrentOrder: null,
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    // 价格类型颜色
    getTypeColor(type) {
      if (type == 1) {
        return 'color:#00C48C; font-weight:bold';
      } else if (type == 2) {
        return 'color:#1989FA; font-weight:bold';
      }
      return '';
    },

    // 订单状态颜色
    getStatusColor(status) {
      const map = {
        1: 'color:#999',        // 待付款
        2: 'color:#F56C6C',      // 待发货
        3: 'color:#E6A23C',      // 待收货
        4: 'color:#00C48C',      // 已完成
        5: 'color:#666'          // 已取消
      };
      return map[status] || '';
    },

    // 发货
    async handleDelivery(row) {
      try {
        await this.$confirm('确定发货？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        this.loading = true;
        const res = await api.orders.delivery({ order_id: row.id });
        if (res.data.code == 1000) {
          this.getOrderList();
        } else {
        }
      } catch (err) {
        this.$message.info('已取消操作');
      } finally {
        this.loading = false;
      }
    },

    // 取消订单
    async handleCancelOrder(row) {
      try {
        await this.$confirm('确定取消该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        this.loading = true;
        const res = await api.orders.cancel({ order_id: row.id });
        if (res.data.code == 1000) {
          this.getOrderList();
        } else {
        }
      } catch (err) {
        this.$message.info('已取消操作');
      } finally {
        this.loading = false;
      }
    },

    getOrderList() {
      this.loading = true;
      // 接口参数：用 params 包裹，适配大多数后端
      api.orders.index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getOrderStatusText(status) {
      const item = this.orderStatusList.find((i) => i.value == status);
      return item ? item.label : "未知状态";
    },
    handlePcRowClick(row) {
      this.pcCurrentOrder = row;
      this.pcShowCard = true;
    },
    handlePcView(row) {
      this.pcCurrentOrder = row;
      this.pcShowCard = true;
    },
    handleMobileRowClick(row) {
      this.mobileCurrentOrder = row;
      this.mobileShowCard = true;
    },
    handleMobileView(row) {
      this.mobileCurrentOrder = row;
      this.mobileShowCard = true;
    },
    resetSearch() {
      // 修复：不替换对象，逐个赋值，保留响应式
      this.searchParams.page = 1;
      this.searchParams.page_size = 15;
      this.searchParams.order_no = "";
      this.searchParams.type = "";
      this.searchParams.status = "";
      this.getOrderList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getOrderList();
    },
  },
};
</script>

<style scoped>
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.order-card {
  padding: 10px;
}
.order-info p {
  margin: 10px 0;
  line-height: 1.6;
}
.order-info label {
  font-weight: bold;
  width: 100px;
  display: inline-block;
}

.mobile-order-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.info .title {
  font-size: 16px;
  font-weight: 500;
}
.info .meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 12px;
  background: #f5f5f5;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.card-footer {
  text-align: right;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/pages/goods/shopOrder.vue